import { render, staticRenderFns } from "./RemoveDDA.vue?vue&type=template&id=4ed9f90e"
import script from "./RemoveDDA.vue?vue&type=script&lang=ts"
export * from "./RemoveDDA.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports